/* apex-policy.js — the /policies/* pages.

   Shopify renders its own markup for a policy — shopify-policy__container,
   __title and __body — and ignores templates/policy.liquid entirely. It cannot
   be made to render a theme template, so the page is reshaped here instead:
   the container is rewritten into the same header-plus-rail-plus-prose that
   the guide article and the FAQ use.

   This runs before apex-guide.js (both deferred, in document order), so by the
   time that file looks for #aprose the article exists and it builds the
   contents list from the policy's own H2s — 13 for privacy, 18 for terms,
   7 for refunds.

   If Shopify ever starts honouring the template, #aprose will already exist and
   this does nothing. */
(function () {
  var box = document.querySelector('.shopify-policy__container');
  if (!box || document.getElementById('aprose')) return;

  var title = box.querySelector('.shopify-policy__title h1');
  var body = box.querySelector('.shopify-policy__body .rte') ||
             box.querySelector('.shopify-policy__body');
  if (!title || !body) return;

  var name = (title.textContent || 'Policy').trim();

  /* ── header ── */
  var head = document.createElement('section');
  head.className = 'apx apx-sec apx-sec--white apx-pol__hd';
  head.innerHTML =
    '<div class="apx-wrap"><div class="ahd">' +
      '<nav class="crumb" aria-label="Breadcrumb">' +
        '<a href="/">Home</a>' +
        '<span aria-hidden="true">›</span>' +
        '<span aria-current="page"></span>' +
      '</nav>' +
      '<h1></h1>' +
    '</div></div>';
  head.querySelector('.crumb span[aria-current]').textContent = name;
  head.querySelector('h1').textContent = name;

  /* ── body ── */
  var main = document.createElement('section');
  main.className = 'apx apx-sec apx-sec--white apx-pol__bd';
  main.innerHTML =
    '<div class="apx-wrap"><div class="alayout alayout--read">' +
      '<aside class="aside">' +
        '<div class="aside__desk">' +
          '<span class="aside__lbl">On this page</span>' +
          '<nav class="atoc" data-atoc aria-label="On this page"></nav>' +
        '</div>' +
        '<details class="aside__m">' +
          '<summary>On this page</summary>' +
          '<nav class="atoc" data-atoc aria-label="On this page"></nav>' +
        '</details>' +
      '</aside>' +
      '<div class="acol">' +
        '<article class="aprose" id="aprose" data-atoc-number="off"></article>' +
      '</div>' +
    '</div></div>';

  /* move the policy text across rather than copying it, so nothing is
     duplicated for a screen reader and no markup is re-parsed */
  var prose = main.querySelector('#aprose');
  while (body.firstChild) prose.appendChild(body.firstChild);

  box.parentNode.insertBefore(head, box);
  box.parentNode.insertBefore(main, box);
  box.parentNode.removeChild(box);
})();
